import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReviewFileLinkPipe } from './review-file-link.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ReviewFileLinkPipe
  ],
  exports: [
    ReviewFileLinkPipe
  ]
})
export class ReviewFileLinkModule { }
